import { createContext, useState, useMemo } from "react";
import PropTypes from "prop-types";
import { mapFilterOptions } from "../common/MapComponent/MapUtils";
const GlobalStoreContext = createContext();
const GlobalStoreProvider = ({ children }) => {
  const [storeGrps, setStoreGrps] = useState([]);
  const [countries, setCountries] = useState([]);
  const [stores, setStores] = useState([]);
  const [brands, setBrands] = useState([]);
  const [selectedStoreGrp, setSelectedStoreGrp] = useState("all");
  const [selectedCountry, setSelectedCountry] = useState("all");
  const [selectedStore, setSelectedStore] = useState("all");
  const [selectedBrand, setSelectedBrand] = useState("all");
  const [mapFilter, setMapFilter] = useState("Business Outage");
  const [chartFilter, setChartFilter] = useState("LY");
  const [currentScreen, setCurrentScreen] = useState("global-store"); // "global-store", "store-issues", "store-notification"
  const [storeFilter, setStoreFilter] = useState("All Stores");
  const [vendors, setVendors] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState("");
  const [selectedStoreDetail, setSelectedStoreDetail] = useState([]);
  const [filterRes, setFilterRes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isKpiLoading, setIsKpiLoading] = useState(false);
  const [statusCardData, setStatusCardData] = useState([]);
  const [kpiData, setKpiData] = useState([]);
  const [carouselData, setCarouselData] = useState([]);
  const [mapData, setMapData] = useState([]);
  const [callAPI, setcallAPI] = useState(true);
  const [callDynamicAPI, setCallDynamicAPI] = useState(true);
  const [highVolumeFilter, setHighVolumeFilter] = useState(mapFilterOptions);

  const contextValue = useMemo(
    () => ({
      storeGrps,
      setStoreGrps,
      countries,
      setCountries,
      stores,
      setStores,
      brands,
      setBrands,
      selectedStoreGrp,
      setSelectedStoreGrp,
      selectedCountry,
      setSelectedCountry,
      selectedStore,
      setSelectedStore,
      selectedBrand,
      setSelectedBrand,
      mapFilter,
      setMapFilter,
      chartFilter,
      setChartFilter,
      currentScreen,
      setCurrentScreen,
      storeFilter,
      setStoreFilter,
      vendors,
      setVendors,
      selectedVendor,
      setSelectedVendor,
      selectedStoreDetail,
      setSelectedStoreDetail,
      filterRes,
      setFilterRes,
      isLoading,
      setIsLoading,
      isKpiLoading,
      setIsKpiLoading,
      statusCardData,
      setStatusCardData,
      kpiData,
      setKpiData,
      carouselData,
      setCarouselData,
      mapData,
      setMapData,
      callAPI,
      setcallAPI,
      callDynamicAPI,
      setCallDynamicAPI,
      highVolumeFilter,
      setHighVolumeFilter,
    }),
    [
      storeGrps,
      countries,
      stores,
      brands,
      selectedStoreGrp,
      selectedCountry,
      selectedStore,
      selectedBrand,
      mapFilter,
      chartFilter,
      currentScreen,
      storeFilter,
      vendors,
      selectedVendor,
      selectedStoreDetail,
      filterRes,
      isLoading,
      isKpiLoading,
      statusCardData,
      kpiData,
      carouselData,
      mapData,
      callAPI,
      callDynamicAPI,
      highVolumeFilter,
    ]
  );

  return (
    <GlobalStoreContext.Provider value={contextValue}>
      {children}
    </GlobalStoreContext.Provider>
  );
};

export { GlobalStoreContext, GlobalStoreProvider };
GlobalStoreProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
